import { Component } from "@angular/core";
import { MenuItem } from "primeng/api";
import { environment } from "environments/environment";
import { AuthService } from "@/shared/auth.service";
import { DialogBaseComponent } from "@/shared/dialog-base.component";
import { DialogService } from "primeng/dynamicdialog";
import { AppConfigDialogComponent } from "./app-config-dialog.component";

@Component({
  selector: "uni-administration-manager",
  standalone: false,
  templateUrl: "./administration-manager.component.html",
})
export class AdministrationManagerComponent {
  isSidebarCollapsed = false;
  items: MenuItem[] = [];

  constructor(
    private authService: AuthService,
    public pngDialogService: DialogService,
  ) {
    this.items = this.buildItems();
  }

  toggleSidebar(): void {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
  }

  private buildItems(): MenuItem[] {
    const user = this.authService.getUser();
    const isUserAdmin = !!user?.isUserAdmin;
    const isAccountingAdmin = !!user?.isAccountingAdmin;

    const operationsItems: MenuItem[] = [
      {
        label: "Access",
        icon: "pi pi-fw pi-users",
        routerLink: ["/administration/manage/user-accounts"],
      },
      {
        label: "Order Analysis",
        icon: "pi pi-fw pi-search",
        routerLink: ["/administration/manage/order-analysis"],
      },
      {
        label: "Proximity API",
        icon: "pi pi-fw pi-server",
        routerLink: ["/administration/manage/proximity-api"],
      },
      {
        label: "Notification Templates",
        icon: "pi pi-fw pi-envelope",
        routerLink: ["/administration/manage/notifications"],
      },
      {
        label: "Hangfire Dashboard",
        icon: "pi pi-fw pi-bolt",
        url: environment.apiRoot + "hangfire",
        target: "_blank",
      },
      {
        label: "Hangfire Jobs",
        icon: "pi pi-fw pi-list",
        routerLink: ["/administration/manage/hangfire-jobs"],
      },
    ];

    const accountingItems: MenuItem[] = [
      {
        label: "GL Submissions",
        icon: "pi pi-fw pi-file-invoice-dollar",
        routerLink: ["/administration/manage/gl-submission"],
      },
    ];
    if (isAccountingAdmin) {
      accountingItems.push(
        {
          label: "QuickBooks Audit",
          icon: "pi pi-fw pi-check-square",
          routerLink: ["/administration/manage/qb-audit"],
        },
        {
          label: "QBO Test",
          icon: "pi pi-fw pi-cloud",
          routerLink: ["/administration/manage/qbo-test"],
        },
        {
          label: "QBO Account Setup",
          icon: "pi pi-fw pi-money-bill",
          routerLink: ["/administration/manage/qb-config"],
        },
      );
    }

    const developerItems: MenuItem[] = [
      {
        label: "API Documentation",
        icon: "pi pi-fw pi-book",
        url: environment.apiRoot + "swagger/index.html",
        target: "_blank",
      },
      {
        label: "Technical Documentation",
        icon: "pi pi-fw pi-file-lines",
        routerLink: ["/tech-docs/manage"],
      },
    ];
    if (isUserAdmin) {
      developerItems.push(
        {
          label: "Configuration",
          icon: "pi pi-fw pi-cog",
          command: () => {
            DialogBaseComponent.open(AppConfigDialogComponent, this);
          },
        },
        {
          label: "Sentry",
          icon: "pi pi-fw pi-exclamation-triangle",
          url: "https://sentry.io/organizations/unitec-distribution-sytems/issues/?project=6440781",
          target: "_blank",
        },
      );
    }

    const utilitiesItems: MenuItem[] = [
      {
        label: "Manufacturer Feed",
        icon: "pi pi-fw pi-cloud-download",
        routerLink: ["/administration/manage/manufacturer-feed"],
      },
      {
        label: "Stranded Job Orders",
        icon: "pi pi-fw pi-flag",
        routerLink: ["/administration/manage/utilities/stranded-orders"],
      },
      {
        label: "Enable Account Inventory",
        icon: "pi pi-fw pi-box",
        routerLink: ["/administration/manage/utilities/enable-account-inventory"],
      },
    ];

    const documentationItems: MenuItem[] = [
      {
        label: "Auto-Notes Catalog",
        icon: "pi pi-fw pi-book",
        routerLink: ["/administration/manage/docs/auto-notes-catalog"],
      },
      {
        label: "Unwind & Reconciliation",
        icon: "pi pi-fw pi-book",
        routerLink: ["/administration/manage/docs/unwind-and-reconciliation"],
      },
    ];

    return [
      {
        label: '<span class="text-l font-bold">Operations</span>',
        escape: false,
        expanded: true,
        items: operationsItems,
      },
      {
        label: '<span class="text-l font-bold">Accounting</span>',
        escape: false,
        expanded: true,
        items: accountingItems,
      },
      {
        label: '<span class="text-l font-bold">Developer</span>',
        escape: false,
        expanded: true,
        items: developerItems,
      },
      {
        label: '<span class="text-l font-bold">Utilities</span>',
        escape: false,
        expanded: true,
        items: utilitiesItems,
      },
      {
        label: '<span class="text-l font-bold">Documentation</span>',
        escape: false,
        expanded: true,
        items: documentationItems,
      },
    ];
  }
}
